









import { Component, Vue } from 'vue-property-decorator';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit } from '@/queries/__generated__/currentUnit';
import { SmartQuery } from 'vue-apollo-decorator';
import WebstoreApiTokenForm from './WebstoreApiTokenForm.vue';
import { GQL_WebstoreApiTokenCreate } from '@/queries/global';
import gql from 'graphql-tag';

const CREATE_WEBSTORE_API_TOKEN = gql`
  mutation createWebstoreApiToken($webstoreApiToken: WebstoreApiTokenCreate!) {
    createWebstoreApiToken(
      input: {
        webstoreApiToken: $webstoreApiToken
      }
    ) {
      webstoreApiToken {
        id,
        tokenValue
      }
    }
  },
`;

@Component({
  components: {
    WebstoreApiTokenForm,
  },
})
export default class WebstoreApiTokenNew extends Vue {
  @SmartQuery<WebstoreApiTokenNew, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.data.unitId = data.currentUnit.id;
    },
  }) private currentUnit!: GQL_currentUnit;

  private CREATE_WEBSTORE_API_TOKEN = CREATE_WEBSTORE_API_TOKEN;

  private data: GQL_WebstoreApiTokenCreate = {
    unitId: '',
    description: '',
    expiryDate: null,
  };
}
